import router  from "./router/index";

router.beforeEach((to, form, next) => {
  document.title = to.meta.title|| '癌筛服务权益领取'
  next()
})